import { lazy } from 'react'

export const EditGeneralInfoLazy = lazy(() => import('./EditGeneralInfo'))
